module.exports = __webpack_public_path__ + "static/img/poster2.91a5c314.jpg";